import {
  ATTENDANCE_ENDPOINT,
  ATTENDANCE_CREATE_ENDPOINT,
  ATTENDANCE_UPDATE_ENDPOINT,
  ATTENDANCE_SHOW_ENDPOINT,
  ATTENDANCE_DELETE_ENDPOINT,
} from 'constants/EndPoints'
import { get, post } from 'services/network'

export const getAttendance = async (id, page, perPage, search) => {
  // console.log(id, perPage, page, search)
  try {
    const response = await get(
      `${ATTENDANCE_ENDPOINT}?` +
        `id=${id}&` +
        `perPage=${perPage}&` +
        `page=${page}&` +
        `search=${search}`,
      true
    )

    return response
  } catch (error) {
    console.error(error)
    return error
  }
}

export const createAttendance = async (values) => {
  try {
    const response = await post(ATTENDANCE_CREATE_ENDPOINT, values, true)
    return response
  } catch (error) {
    console.error(error)
    return error
  }
}

export const updateAttendance = async (values, id) => {
  try {
    const response = await post(
      `${ATTENDANCE_UPDATE_ENDPOINT}/${id}`,
      values,
      true
    )
    return response
  } catch (error) {
    console.error(error)
    return error
  }
}

export const showAttendance = async (id) => {
  try {
    const response = await get(`${ATTENDANCE_SHOW_ENDPOINT}/${id}`, true)
    return response
  } catch (error) {
    console.error(error)
    return error
  }
}

export const minioSingleFileUpload = async (file) => {
  try {
    const response = await post('', file, false, 'https://my-site/minio/upload')
    return response
  } catch (error) {
    console.error(error)
    return error
  }
}

export const deleteAttendance = async (id) => {
  try {
    const response = await post(
      `${ATTENDANCE_DELETE_ENDPOINT}/${id}`,
      null,
      true
    )
    return response
  } catch (error) {
    console.error(error)
    return error
  }
}
